import React, { FC } from 'react';
import { Redirect } from 'react-router';

import { UnbrandedLoadingScreen } from '@modernloop/shared/helper-components';

import { useHasEmployeePermission } from 'src/shared/permissions/useCurrentUserPermissions';

/**
 * Guard that checks if the user has interviewer permissions. If not, redirects to logout.
 * Note: Guards should check only one thing. Don't add any other checks to this Guard.
 */
const IPUserHasInterviewPermissionGuard: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { permission: canInterview, loading } = useHasEmployeePermission('CAN_INTERVIEW');

  if (loading) {
    return <UnbrandedLoadingScreen />;
  }

  if (!canInterview) {
    return <Redirect to="/logout" />;
  }

  // Don't add components here, please add components either on the app or on the appropriate Layout component
  return <>{children}</>;
};

export default IPUserHasInterviewPermissionGuard;
